module.exports = __webpack_public_path__ + "img/tixing.213e2136.png";